import { useTranslation } from 'react-i18next';
import { Image } from 'antd';
import * as Styled from './styles';
import { getPath } from 'utils';
import registrationSuccess from 'assets/images/Reward.png';

export const RegisterCompanyStepThree = () => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ height: 300 }} />
      <Styled.Wrapper>
        <Styled.TextIconWrapper>
          <Image
            src={registrationSuccess}
            alt={t('account.registrationSuccess')}
            preview={false}
          />
          <Styled.TextWrapper>
            <Styled.TextHeading>
              {t('account.thankYouForTheSubmission')}
            </Styled.TextHeading>
            <Styled.TextDescription>
              {t('account.weWillGetBackAfterReviewingSubmission')}
            </Styled.TextDescription>
          </Styled.TextWrapper>
          <Styled.Button
            type="primary"
            onClick={() => (window.location.href = getPath('/'))}
          >
            {t('account.goHome')}
          </Styled.Button>
        </Styled.TextIconWrapper>
      </Styled.Wrapper>
    </>
  );
};
